<template>
    <div class="investors-s">
        <p class="indent">Il capitale della società è suddiviso in 17 952 959 azioni, ciascuna del valore nominale di 1 BGN.</p>
        <p class="indent">Le azioni della Società sono quotate per la negoziazione nel Mercato non ufficiale dei titoli sotto l’emissione BG11ALSUAT14 come azioni nominative inscindibili dematerializzate che danno diritto al voto, diritto al dividendo e diritto alla quota di liquidazione in proporzione al valore nominale dell'azione ai sensi del Codice di Borsa 6AM /ALUM/.</p>
        <img class="investors-chart" src="/static/img/investors/shares/chart.svg" alt="Chart">
        <p class="indent">I diritti connessi alle azioni emesse dalla Società sono certificati da un documento emesso dalla Central Depository AD, non trasferibile. Le azioni possono essere liberamente trasferite tra gli azionisti e con terzi in conformità con le disposizioni applicabili della legislazione bulgara. La Società non ha diritto di emettere azioni privilegiate che diano diritto a due o più voti o quote aggiuntive di liquidazione.</p>
        <p class="indent">Il Libro dei soci della Società è tenuto dalla Central Depository  AD di Sofia in conformità con la procedura legale.</p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-s {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.investors-s > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-s > p:last-of-type {
  margin-bottom: 0;
}
.investors-chart {
  margin: 20px 0 0;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .investors-s > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-chart {
    width: calc(100% - 30px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Shares.vue